import moment from "moment";
import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useLazyQuery, useMutation } from "@apollo/client";

import FeelingFaces from "../../components/MoodMeterBlock/FeelingFaces/FeelingFaces";
import StepperLine from "../../components/StepperLine/StepperLine";
import FeelingOptions from "../../components/MoodMeterBlock/FeelingOptions/FeelingOptions";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import { CREATE_USERS_FEELING } from "../../GraphQL/Mutations";
import { ROLES } from "../../util/RolesConstants";
import { MoodMeterHomeContent } from "./MoodMeterHomeContainer.styled";
import { ReactComponent as SaveMood } from "../../assets/svg/save-mood.svg";
import { SaveMoodSvg } from "../MoodMeterContainer/MoodMeterContainer.styled";
import { theme as themeConfig } from "../../themes/themes";
import {
  ALL_REASONS,
  ALL_SMILEYS,
  CURRENT_USER_SUPERVISOR,
  MOOD_METER_GET_CONFIGURATION,
  USERS_FEELING_BY_USER_AND_DATE,
} from "../../GraphQL/Queries";

const MoodMeterHomeContainer = () => {
  const [createUsersFeeling] = useMutation(CREATE_USERS_FEELING);
  const [faces, setFaces] = useState([]);
  const [step, setSteps] = useState(1);
  const [user] = useState(getStateLoginComplete());
  const [faceSelect, setFaceSelect] = useState(0);
  const [options, setOptions] = useState([]);
  const [optionsDetails] = useState([]);
  const [optionResponse, setOptionResponse] = useState();
  const [detailResponse, setDetailResponse] = useState([]);
  const [checkMailingWellness, setCheckMailingWellness] = useState(false);
  const [checkMailingSupervisor, setCheckMailingSupervisor] = useState(false);
  const [stateSave, setStateSave] = useState(false);
  const [timeConfig, setTimeConfig] = useState();
  const [superVisorId, setSuperVisorId] = useState();
  const [messageConfigAdmin, setMessageConfigAdmin] = useState();
  const [openConfigAdmin, setOpenConfigAdmin] = useState(false);

  const [runQueryAllReaseons, { loading: loadingReasons }] = useLazyQuery(
    ALL_REASONS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allReasons.withError) {
          let reasons = data.allReasons.outputData.filter(
            (reasons) => reasons.recordState === "Active"
          );
          setOptions(reasons);
        } else {
          NotificationManager.error(data.allReasons.message, "", 5000);
        }
      },
    }
  );

  const [runQueryAllFaces, { loading: loadingFace }] = useLazyQuery(
    ALL_SMILEYS,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (!data.allSmileys.withError) {
          let allFaces = data.allSmileys.outputData
            .filter((f) => f.recordState === "Active")
            .map((item) => ({ ...item }));
          allFaces = arrangeSmileyByCategory(allFaces);
          setFaces([...allFaces]);
        } else {
          NotificationManager.error(data.allSmileys.message, "", 5000);
        }
      },
    }
  );

  const [runQueryGetUserInfo] = useLazyQuery(CURRENT_USER_SUPERVISOR, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const superVisor = data?.currentUser[0]?.supervisorId;
      if (superVisor && superVisor !== null) {
        setSuperVisorId(superVisor);
      }
    },
  });

  const [handlerUsersFeelingByUserId] = useLazyQuery(
    USERS_FEELING_BY_USER_AND_DATE,
    {
      fetchPolicy: "network-only",
      nextFetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        if (!data.usersFeelingByUserAndDate.withError) {
          if (data?.usersFeelingByUserAndDate?.outputData?.length > 0) {
            let allFeelingsToday = data.usersFeelingByUserAndDate.outputData;
            validateShowMessage(allFeelingsToday, allFeelingsToday.length);
          } else {
            let allFeelingsToday = !data?.usersFeelingByUserAndDate?.outputData
              ? []
              : data.usersFeelingByUserAndDate.outputData;
            validateShowMessage(allFeelingsToday, allFeelingsToday.length);
          }
        } else {
          NotificationManager.error(
            data.usersFeelingByUserAndDate.message,
            "",
            5000
          );
        }
      },
    }
  );

  const [runQueryGetTimeConfig] = useLazyQuery(MOOD_METER_GET_CONFIGURATION, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      handlerUsersFeelingByUserId({
        variables: {
          userId: user.userId,
          dateEntry: new Date().toISOString(),
        },
      });
      if (!data.moodMeterGetConfiguration.withError) {
        setTimeConfig(data.moodMeterGetConfiguration.outputData);
      } else {
        NotificationManager.error(
          data.moodMeterGetConfiguration.message,
          "",
          5000
        );
      }
    },
  });

  const validateShowMessage = (allFeelingsToday, counter) => {
    if (counter === 0) {
      setOpenConfigAdmin(true);
    } else if (counter < timeConfig?.recordsPerDay) {
      let lastDate = new Date(
        allFeelingsToday[allFeelingsToday.length - 1]?.createDate
      );
      let intervalDate = new Date(
        lastDate.setHours(lastDate.getHours() + timeConfig?.intervalDuration)
      );
      let newDate = moment(new Date()).utc().format();
      let futureDate = moment(intervalDate).utc().format();
      if (newDate > futureDate) {
        setOpenConfigAdmin(true);
      } else {
        setOpenConfigAdmin(false);
        setMessageConfigAdmin(
          `This feature is disabled for ${timeConfig?.intervalDuration} hours after using it...`
        );
      }
    } else {
      // openMoodmeterDialog(false);
    }
  };

  useEffect(() => {
    runQueryAllFaces();
    runQueryGetTimeConfig();
  }, []);

  useEffect(() => {
    if (faceSelect) {
      runQueryAllReaseons();
    }
  }, [faceSelect]);

  useEffect(() => {
    if (user) {
      runQueryGetUserInfo({
        context: { clientName: "LinkUsers" },
      });
    }
  }, [user]);

  const handleOptionByReason = (option) => {
    if (option) {
      setOptionResponse(option);
    } else {
      setOptionResponse();
    }
    setDetailResponse([]);
  };

  const handleOptionByDetails = (detalis) => {
    let detalisSelect = [];

    detalis.forEach((element) => {
      detalisSelect.push(element);
    });

    setDetailResponse(detalisSelect);
  };

  const arrangeSmileyByCategory = (data) => {
    return data.sort((a, b) => {
      return a.category - b.category;
    });
  };

  const handleBackFeelingOptions = () => {
    setFaceSelect();
    setSteps(1);
  };

  const saveMoodMeter = (reasonId) => {
    setStateSave(true);
    createUsersFeeling({
      variables: {
        idSmiley: faceSelect.idSmiley,
        idReason: reasonId,
        mailingWellness: checkMailingWellness,
        mailingSupervisor: checkMailingSupervisor,
      },
    }).then(
      (saveResponse) => {
        setStateSave(false);
        if (!saveResponse.data.createUsersFeeling.withError) {
          setSteps(4);
        } else {
          let errorMessage = `${saveResponse?.data?.createUsersFeeling?.message}`;
          NotificationManager.error(errorMessage, "", 5000);
        }
      },
      (error) => {
        setStateSave(false);
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      }
    );
  };
  return (
    <>
      {loadingFace || loadingReasons || stateSave}
      <MoodMeterHomeContent>
        <>
          {openConfigAdmin && step === 1 && (
            <FeelingFaces
              title="How are you feeling today?"
              faces={faces}
              faceSelect={faceSelect}
              setFaceSelect={setFaceSelect}
              handler={() => setSteps(2)}
              type="home"
            ></FeelingFaces>
          )}
          {(user.roleId === ROLES.AGENT ||
            user.roleId === ROLES.GAM ||
            user.roleId === ROLES.SUPER_ADMIN ||
            user.roleId === ROLES.COUNTRY_ADMIN ||
            user.roleId === ROLES.WELLNESS_PROFESSIONAL) &&
            !openConfigAdmin &&
            step !== 4 && (
              <div className="mood-meter_disabled">
                <SaveMoodSvg>
                  <SaveMood />
                </SaveMoodSvg>
                <h6
                  style={{
                    margin: "1em",
                    fontWeight: "600",
                    textAlign: "center",
                    color: themeConfig.text.primary,
                    fontSize: "14px",
                  }}
                >
                  {messageConfigAdmin}
                </h6>
              </div>
            )}
          {(step == 2 || step == 3) && (
            <div>
              <FeelingOptions
                title={timeConfig?.questionForUser}
                options={options}
                faceSelect={faceSelect}
                backTOParent={handleBackFeelingOptions}
                handleOption={handleOptionByReason}
                optionsDetails={optionsDetails}
                handleOptionDetails={handleOptionByDetails}
                detailTitle="Could you tell us the main reason why?"
                selectedReason={optionResponse}
                selectedDetailedReason={detailResponse}
                setCheckMailingWellness={setCheckMailingWellness}
                setCheckMailingSupervisor={setCheckMailingSupervisor}
                checkMailingWellness={checkMailingWellness}
                checkMailingSupervisor={checkMailingSupervisor}
                handleNext={saveMoodMeter}
                updateStepper={setSteps}
                superVisorId={superVisorId}
                isSaving={stateSave}
              ></FeelingOptions>
            </div>
          )}
          {step == 4 && (
            <div className="save-mood">
              <SaveMoodSvg>
                <SaveMood />
              </SaveMoodSvg>
              <div className="save-mood_info">
                <strong
                  style={{
                    fontWeight: 700,
                    fontSize: "22px",
                    color: themeConfig.text.primary,
                  }}
                >
                  Done
                </strong>
                <br />
                {faceSelect?.category <= 3 && (
                  <>
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: "16px",
                        color: themeConfig.text.primary,
                      }}
                    >
                      Thank you for sharing your mood..
                    </span>
                    <br />
                  </>
                )}
              </div>
            </div>
          )}
        </>
        {!messageConfigAdmin && <StepperLine activeStep={step}></StepperLine>}
      </MoodMeterHomeContent>
    </>
  );
};

export default MoodMeterHomeContainer;
